require("./registrationController");
require("../shared/selectWithDisabledOption/selectWithDisabledOptionDirective");
require("./confirmation/confirmationController");
require('../shared/password/passwordDirective');

/**
 * @typedef {{
 * confirmation: string,
 * plan_code: string
 * }} RegistrationParams
 */

angular.module('app.registration', [
  'app.registration.registrationController',
  'app.shared.selectWithDisabledOption.selectWithDisabledOptionDirective',
  'app.registration.confirmation.confirmationController',
  'app.shared.password.passwordDirective'
])
  .config([
    '$stateProvider', 'PRODUCT',
    function ($stateProvider, product) {
      'use strict';

      let regTemplate = 'components/registration/registrationView.html';
      if (product.Code != 'htv') {
        regTemplate = 'assets/templates/' + product.Code + '/registration/registrationView.html';
      }

      $stateProvider
        .state('app.registration', {
          abstract: true,
          url: '/registration',
          template: '<ui-view></ui-view>',
        })
        .state('app.registration.new', {
          url: '/new',
          templateUrl: regTemplate,
          controller: 'app.registration.registrationController',
          title: ' ',
          subTitle: 'Registration',
          isChildState: false,
          noSidebar: true,
          noTitleBar: true,
          params: {
            loginRedirect: null,
            loginRedirectParams: null,
            plan_code: null,
            team: null
          }
        })
        .state('app.registration.confirmation', {
          url: '/confirm/:userId/:confirmation?:plan_code&:team',
          templateUrl: 'components/registration/confirmation/confirmationView.html',
          controller: 'app.registration.confirmation.confirmationController',
          title: 'Registration Confirmation',
          noSidebar: true
        });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/registration/registration.js